import { Goal } from './Goal';

export const kind = 'Start';

// DEPRECATED: Under Replication V2, `Start` does not really do anything useful;
// `replicationLifeCycle` will automatically start replication if all of the necessary conditions are met.
// TODO: clean this up https://nutrien.atlassian.net/browse/MDP-8188
export type Start = Goal<typeof kind>;
